export default __webpack_public_path__ + "static/media/testBg.adc76bc2.png";